module.exports = __webpack_public_path__ + "img/msc.2b4107ca.svg";